module.exports = __webpack_public_path__ + "static/no-access-img.4c227c22.png";